var _path, _path2, _path3, _line, _path4, _path5, _path6, _rect, _path7, _path8, _line2, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _circle, _circle2, _rect2, _rect3, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _ellipse, _path16, _line3, _line4, _line5, _path17, _path18, _path19, _line6, _line7, _g, _path20, _path21, _path22, _path23, _path24, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg503(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1109,
    height: 558,
    viewBox: "0 0 1109 558",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M646 270L679.5 226.5L613.5 232.5L643.5 181L582.5 185L613.5 143L559 146.5L580.5 104.5L538 114L553 74L515.5 78L524.5 64.5",
    stroke: "#264C73",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M251 196L256.5 172.5L281 181L285.5 156L315 164V138L345 148L343.5 122L378.5 131V99.5L414.5 115L410.5 79.5L447.5 96L446.5 60.5L486.5 77L482 51.5",
    stroke: "#264C73",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M495.013 44.1971C493.116 41.1662 493.714 37.2048 496.421 34.8686L506.317 26.3261C509.376 23.6865 514.002 24.0576 516.6 27.151L713.208 261.23L659.071 306.368L495.013 44.1971Z",
    stroke: "#0B2642",
    strokeWidth: 7.24567
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 795.682,
    y1: 179.462,
    x2: 794.623,
    y2: 256.05,
    stroke: "#013556",
    strokeWidth: 7.24567
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M815.029 107.416C813.709 103.872 810.324 101.521 806.542 101.521H732.094C727.887 101.521 724.234 104.418 723.275 108.514L690.207 249.805C688.877 255.487 693.19 260.926 699.026 260.926H845.59V189.449L815.029 107.416Z",
    stroke: "#F8CF4E",
    strokeWidth: 10.8685
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M244.803 215.641C244.803 215.641 227.896 214.45 227.896 230.149C227.896 245.847 248.426 247.039 253.256 238.586",
    stroke: "#013556",
    strokeWidth: 4.83045,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M952.464 161.299H941.595C935.593 161.299 930.727 166.165 930.727 172.167V204.773",
    stroke: "#013556",
    strokeWidth: 10.8685,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: -2.5,
    width: 619,
    height: 109,
    rx: 54.5,
    transform: "matrix(-1 0 0 1 1109 335)",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeDasharray: "10 10"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M956.377 209.737C956.377 199.733 948.267 191.623 938.263 191.623H854.623V255.377H938.263C948.267 255.377 956.377 247.267 956.377 237.263V209.737Z",
    fill: "#F8CF4E",
    stroke: "#013556",
    strokeWidth: 7.24567
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1032.05 324.327C1030.18 294.001 1005 269.984 974.201 269.984H622.786C591.989 269.984 566.802 294.001 564.932 324.327H1032.05Z",
    fill: "#013556",
    stroke: "#F8CF4E",
    strokeWidth: 7.24567
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 709.733,
    y1: 177.6,
    x2: 840.156,
    y2: 177.6,
    stroke: "#F8CF4E",
    strokeWidth: 10.8685
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M716.183 169.5L730.81 109.5H806.036L801.786 169.5H716.183Z",
    fill: "#F28A41",
    stroke: "#013556",
    strokeWidth: 5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M244.803 195.716L244.803 215.641",
    stroke: "#013556",
    strokeWidth: 4.83045
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M151.157 275.541L234.482 242.935",
    stroke: "black",
    strokeWidth: 3.62284,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M242.388 244.624L372.81 335.195",
    stroke: "black",
    strokeWidth: 3.62284,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0683 298.423C99.7647 277.163 121.617 264.547 142.876 270.243L391.333 336.817C412.592 342.514 425.208 364.366 419.512 385.625L394.195 480.108C388.499 501.368 366.647 513.984 345.387 508.287L156.938 457.793L96.9305 441.714C75.6713 436.017 63.0551 414.165 68.7515 392.906L94.0683 298.423Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 7.24567
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M111.823 375.274C113.561 376.838 115.496 378.303 117.628 379.669C119.805 381.009 122.063 382.257 124.402 383.414C126.777 384.58 129.185 385.623 131.626 386.542C134.112 387.435 136.555 388.203 138.957 388.847C143.194 389.982 146.929 390.661 150.162 390.884C153.44 391.081 156.219 390.88 158.5 390.279C160.815 389.689 162.658 388.744 164.028 387.446C165.442 386.122 166.405 384.506 166.916 382.599C167.436 380.657 167.402 378.737 166.813 376.838C166.26 374.949 165.133 373.152 163.432 371.447C161.767 369.752 159.501 368.179 156.635 366.73C153.813 365.255 150.389 363.978 146.363 362.899C144.562 362.417 142.508 361.961 140.201 361.532C137.903 361.068 135.436 360.671 132.798 360.343C130.161 360.015 127.38 359.8 124.456 359.697C121.54 359.56 118.552 359.554 115.49 359.68L128.25 312.06L191.76 329.078L187.772 343.962L139.782 331.103L135.481 347.153C138.29 347.262 141.195 347.511 144.195 347.898C147.204 348.25 150.492 348.904 154.058 349.86C159.885 351.421 164.923 353.452 169.173 355.954C173.423 358.455 176.803 361.31 179.312 364.518C181.856 367.735 183.508 371.244 184.269 375.043C185.04 378.807 184.871 382.755 183.764 386.887C182.619 391.16 180.683 394.785 177.954 397.763C175.271 400.715 171.855 402.941 167.706 404.441C163.592 405.951 158.818 406.677 153.383 406.621C147.983 406.575 141.999 405.672 135.431 403.912C132.041 403.003 128.72 401.905 125.47 400.618C122.245 399.376 119.151 397.998 116.188 396.485C113.234 394.936 110.442 393.28 107.812 391.515C105.226 389.725 102.849 387.858 100.683 385.915L111.823 375.274ZM201.058 375.738C202.846 369.064 205.457 363.348 208.889 358.59C212.321 353.833 216.383 350.114 221.075 347.435C225.776 344.721 231.036 343.102 236.853 342.58C242.67 342.057 248.863 342.675 255.431 344.435C261.999 346.195 267.672 348.756 272.448 352.117C277.225 355.479 280.97 359.51 283.685 364.212C286.408 368.878 288.067 374.129 288.661 379.965C289.254 385.801 288.657 392.057 286.868 398.731C285.08 405.405 282.47 411.121 279.038 415.878C275.605 420.636 271.543 424.354 266.852 427.033C262.16 429.712 256.905 431.313 251.088 431.836C245.27 432.359 239.078 431.741 232.509 429.981C225.941 428.221 220.269 425.66 215.492 422.298C210.716 418.937 206.966 414.923 204.242 410.257C201.518 405.591 199.859 400.34 199.266 394.504C198.672 388.667 199.27 382.412 201.058 375.738ZM217.864 380.184C216.652 384.704 216.183 388.855 216.457 392.638C216.766 396.43 217.733 399.811 219.359 402.783C220.994 405.719 223.253 408.236 226.136 410.333C229.027 412.394 232.486 413.965 236.512 415.043C240.537 416.122 244.318 416.491 247.853 416.152C251.398 415.777 254.612 414.727 257.497 413.002C260.391 411.241 262.902 408.792 265.03 405.653C267.193 402.523 268.88 398.699 270.091 394.179C271.293 389.694 271.735 385.573 271.417 381.817C271.143 378.034 270.194 374.657 268.567 371.686C266.941 368.714 264.682 366.198 261.791 364.136C258.908 362.039 255.454 360.451 251.429 359.372C247.403 358.294 243.618 357.942 240.073 358.317C236.538 358.656 233.324 359.706 230.43 361.467C227.536 363.227 225.007 365.672 222.844 368.802C220.725 371.905 219.065 375.699 217.864 380.184ZM302.618 426.398C306.236 429.563 310.283 432.256 314.76 434.477C319.281 436.672 323.802 438.376 328.322 439.587C332.347 440.666 335.911 441.28 339.012 441.429C342.123 441.544 344.783 441.292 346.993 440.672C349.203 440.053 350.975 439.09 352.309 437.782C353.644 436.474 354.552 434.92 355.035 433.119C355.688 430.683 355.44 428.288 354.291 425.937C353.152 423.55 351.015 421.426 347.88 419.564C344.79 417.676 340.639 416.148 335.427 414.978C330.25 413.818 323.941 413.206 316.502 413.143L319.876 400.763L356.204 388.923L312.398 377.185L316.344 362.46L382.608 380.215L378.748 394.623L346.895 404.596C351.874 405.93 356.153 407.758 359.732 410.079C363.311 412.401 366.145 415.034 368.232 417.977C370.32 420.921 371.663 424.101 372.262 427.516C372.861 430.932 372.692 434.387 371.755 437.883C370.648 442.015 368.722 445.53 365.977 448.428C363.278 451.3 359.876 453.473 355.772 454.947C351.677 456.386 346.947 457.086 341.583 457.049C336.254 457.022 330.428 456.161 324.107 454.467C317.398 452.67 311.39 450.303 306.083 447.367C300.786 444.396 295.917 440.953 291.478 437.038L302.618 426.398Z",
    fill: "#F86841"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M251.542 197.684C248.026 199.486 243.714 198.139 241.849 194.655L239.636 190.521C237.802 187.095 238.997 182.833 242.345 180.86L504.004 26.6348L525.544 57.2367L251.542 197.684Z",
    stroke: "#0B2642",
    strokeWidth: 7.24567
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 506.855,
    cy: 45.3675,
    r: 25.3599,
    fill: "white",
    stroke: "#013556",
    strokeWidth: 7.24567
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 507.5,
    cy: 45.5,
    r: 10.8772,
    fill: "#F28A41",
    stroke: "#013556",
    strokeWidth: 7.24567
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -3.62284,
    y: 3.62284,
    width: 597.768,
    height: 86.9481,
    rx: 43.474,
    transform: "matrix(-1 0 0 1 1092.77 340)",
    fill: "#013556",
    stroke: "#0B2642",
    strokeWidth: 7.24567
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -1.81142,
    y: 1.81142,
    width: 550.671,
    height: 54.3425,
    rx: 27.1713,
    transform: "matrix(-1 0 0 1 1071.03 358.115)",
    fill: "#0B2642",
    stroke: "white",
    strokeWidth: 3.62284
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.737,
    cy: 21.737,
    r: 21.737,
    transform: "matrix(-1 0 0 1 1065.79 365.361)",
    fill: "#264C73"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.737,
    cy: 21.737,
    r: 21.737,
    transform: "matrix(-1 0 0 1 1004.2 365.361)",
    fill: "#264C73"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.737,
    cy: 21.737,
    r: 21.737,
    transform: "matrix(-1 0 0 1 942.609 365.361)",
    fill: "#264C73"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.737,
    cy: 21.737,
    r: 21.737,
    transform: "matrix(-1 0 0 1 881.021 365.361)",
    fill: "#264C73"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.737,
    cy: 21.737,
    r: 21.737,
    transform: "matrix(-1 0 0 1 819.433 365.361)",
    fill: "#264C73"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.737,
    cy: 21.737,
    r: 21.737,
    transform: "matrix(-1 0 0 1 757.845 365.361)",
    fill: "#264C73"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.737,
    cy: 21.737,
    r: 21.737,
    transform: "matrix(-1 0 0 1 696.256 365.361)",
    fill: "#264C73"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.737,
    cy: 21.737,
    r: 21.737,
    transform: "matrix(-1 0 0 1 634.668 365.361)",
    fill: "#264C73"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.737,
    cy: 21.737,
    r: 21.737,
    transform: "matrix(-1 0 0 1 573.08 365.361)",
    fill: "#264C73"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 244.5,
    cy: 203,
    rx: 5.5,
    ry: 5,
    fill: "#013556"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M835.5 172L810.432 107.402C810.102 106.551 808.898 106.551 808.568 107.402L783.5 172H835.5Z",
    fill: "#0E4C74"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 881,
    y1: 212,
    x2: 928,
    y2: 212,
    stroke: "black",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 881,
    y1: 224,
    x2: 928,
    y2: 224,
    stroke: "black",
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 881,
    y1: 236,
    x2: 928,
    y2: 236,
    stroke: "black",
    strokeWidth: 2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M708 183H792V255.5H692.5L708 183Z",
    fill: "#013556"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M709.5 212.5L701.258 245.469C700.622 248.013 702.564 250.47 705.185 250.439L742.5 250",
    stroke: "#013556",
    strokeWidth: 10.8685
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M777.5 183H799V255.5H744L777.5 183Z",
    fill: "#0E4C74"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 807.646,
    y1: 223.646,
    x2: 829.646,
    y2: 201.646,
    stroke: "black"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 809.646,
    y1: 235.646,
    x2: 831.646,
    y2: 213.646,
    stroke: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_758_468)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 806,
    cy: 452.5,
    rx: 280,
    ry: 3.5,
    fill: "#E6E6E6"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M986.533 137.046C981.321 132.277 978 125.068 978 117C978 102.641 988.521 91 1001.5 91C1013.56 91 1023.5 101.054 1024.85 114.001L1024.92 114L1025 114C1033.84 114 1041 121.835 1041 131.5C1041 141.165 1033.84 149 1025 149C1021.66 149 1018.56 147.88 1015.99 145.966C1016 146.143 1016 146.321 1016 146.5C1016 156.165 1008.84 164 1000 164C991.163 164 984 156.165 984 146.5C984 143.017 984.93 139.772 986.533 137.046Z",
    fill: "#D9D9D9"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1070.19 95.4433C1075.31 94.0356 1079 90.1156 1079 85.5C1079 79.701 1073.18 75 1066 75C1058.82 75 1053 79.701 1053 85.5C1053 87.4041 1053.63 89.1898 1054.72 90.7296C1051.88 92.6078 1050 95.8346 1050 99.5C1050 105.299 1054.7 110 1060.5 110C1066.3 110 1071 105.299 1071 99.5C1071 98.0619 1070.71 96.6914 1070.19 95.4433Z",
    fill: "#D9D9D9"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M66 245L83 262",
    stroke: "#FF0000",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M91 225L99.4701 247.5",
    stroke: "#FF0000",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M118.198 218.229L118.272 242.271",
    stroke: "#FF0000",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_758_468)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 219,
    cy: 550.5,
    rx: 215,
    ry: 3.5,
    fill: "#E6E6E6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_758_468",
    x: 522,
    y: 445,
    width: 568,
    height: 15,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_758_468"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_758_468",
    x: 0,
    y: 543,
    width: 438,
    height: 15,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_758_468"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg503);
export default __webpack_public_path__ + "static/media/503.5f28425cdd33ed415f371b93d0b68c0c.svg";
export { ForwardRef as ReactComponent };